import { Component, OnDestroy, OnInit, inject, ViewChild } from '@angular/core'
import { FormBuilder, Validators } from '@angular/forms'
import { debounceTime, filter } from 'rxjs/operators';
import { Router } from '@angular/router'
import { firstValueFrom, Observable, Subject, Subscription } from 'rxjs'
import { scrollToInvalidElement } from '../../../shared/utils/utils'
import { ToastrService } from 'ngx-toastr'
import { NgbModal } from '@ng-bootstrap/ng-bootstrap'
import { saveAs } from 'file-saver'
import { ReferenceService } from '../../data-access/http/reference.service'
import { BilanEnergetiqueService } from '../../data-access/http/bilan-energetique.service'
import { SunleonService } from '../../data-access/http/sunleon.service'
import { CsvService } from '../../data-access/http/csv.service'
import { FileUploadService } from '../../data-access/http/file-upload.service'
import { TypeReferenceDto } from '../../data-access/http/dto/type-reference-dto'
import { BilanEnergetiqueDto } from '../../data-access/http/dto/bilan-energetique-dto'
import { SessionZoneSaveDto } from '../../data-access/http/dto/session-zone-save-dto'
import { SessionCommunSaveDto } from '../../data-access/http/dto/session-commun-save-dto'
import { SessionSaveDto } from '../../data-access/http/dto/session-save-dto'
import { AuthService } from '../../../core/services/auth.service'
import { User } from '../../../shared/models/user'
import { GeomapDomainService } from '../../../sungeo/domain/geomap.domain'
import { ReverseGeoCodeGoogleDto } from 'src/app/sungeo/model/address-google-dto';
import { ProcessResultDto } from '../../data-access/http/dto/ProcessResultDto';
import { ModalGenerationLivrableComponent } from 'src/app/sungeo/feature/modals/modal-generation-livrable/modal-generation-livrable.component';
import { GoogleDriveDto } from 'src/app/sungeo/model/google-drive-dto';
import { GoogleDrivePickerService } from '../../data-access/http/google-drive-picker.service';
import { ConfirmationModalComponent } from 'src/app/sungeo/feature/modals/confirmation-modal/confirmation-modal.component';
import { PieceJointeService } from '../../data-access/http/piece-jointe.service';
import { ParametreDto } from 'src/app/parametre/data-access/http/dto/parametre-dto';
import { ParametreSimpleModalComponent } from 'src/app/parametre/feature/modals/parametre-simple-modal/parametre-simple-modal.component';
import { ParametreSpecifiqueBddEnedisModalComponent } from 'src/app/parametre/feature/modals/parametre-specifique-bdd-enedis-modal/parametre-specifique-bdd-enedis-modal.component';
import { ParametreTableauModalComponent } from 'src/app/parametre/feature/modals/parametre-tableau-modal/parametre-tableau-modal.component';
import { TypeEnum } from 'src/app/parametre/models/type.enum';
import { ParametreService } from 'src/app/parametre/data-access/http/parametre.service';
import { ParametreSpecifiqueSaveDto } from 'src/app/parametre/data-access/http/dto/parametre-specifique-save-dto';
import { ParametreTableauSaveDto } from 'src/app/parametre/data-access/http/dto/parametre-tableau-save-dto';

@Component({
  selector: 'app-sunleon-form',
  templateUrl: './sunleon-form.component.html',
  styleUrls: ['./sunleon-form.component.scss'],
})
export class SunleonFormComponent implements OnInit, OnDestroy {
  constructor(
    public authService: AuthService,
    private formBuilder: FormBuilder,
    private router: Router,
    private referenceService: ReferenceService,
    private bilanEnergetiqueService: BilanEnergetiqueService,
    private sunLeonService: SunleonService,
    private toastr: ToastrService,
    public modalService: NgbModal,
    private csvService: CsvService,
    private fileUploadService: FileUploadService,
    private googleDrivePickerService: GoogleDrivePickerService,
    private pieceJointeService: PieceJointeService,
     public parametreService: ParametreService,
  ) {}

  user: User
  message = ''

  @ViewChild('content') modalContent: any

  @ViewChild('contentSuccess') modalContentSuccess: any

  selectedFile: File | undefined

  subscription = new Subscription()
  formIsSubmitting: boolean = false
  formModalIsSubmitting: boolean = false
  modeValorisations: TypeReferenceDto[] = []
  typePoses: TypeReferenceDto[] = []
  typeToitures: TypeReferenceDto[] = []
  typePlaces: TypeReferenceDto[] = []
  typeParkings: TypeReferenceDto[] = []
  dureeContrats: TypeReferenceDto[] = []
  prmCodes: BilanEnergetiqueDto[] = []
  typeGammePanneaux: TypeReferenceDto[] = []
  typeGammeOnduleurs: TypeReferenceDto[] = []

  status: string | undefined
  processIdEnregistrementSimulation: string | undefined
  processIdCreationCsv: string | undefined

  apiMessageSuccess : string = '';
  
  azimutZone1Label = "Azimut (compris entre -180 et 180, SUD = 0)"
  azimutZone2Label = "Azimut (compris entre -180 et 180, SUD = 0)"
  azimutZone3Label = "Azimut (compris entre -180 et 180, SUD = 0)"

  nomCourbeCharge: string = '';

  urlDownloadSimu : string;
  csvPresentation : File;
  csvDevis : File;
  csvVE : File;

  private parametresSimple = new Map<string, string>();
  private parametresTableau = new Map<string, ParametreTableauSaveDto>();
  private parametresSpécifique = new Map<string, ParametreSpecifiqueSaveDto>();

  selectedFormat: 'sunleon' | 'enedis' | null = null;
  nomCourbeChargeError: boolean = false;

  private readonly geomapDomainService = inject(GeomapDomainService)

  sunleonForm = this.formBuilder.group({
    nomClient: ['', [Validators.required]],
    nomProjet: ['', [Validators.required]],
    numMonday: [''],
    latitude: [null, [Validators.required]],
    longitude: [null, [Validators.required]],
    departement: [null as string, [Validators.required, Validators.pattern('^(?!00|20|96|97|98|99)[0-9]{2}$|^(2[AB])$')]],
    puissanceSouscriteKVA: [null, [Validators.pattern('^\\d+$')]],
    modeValorisation: [null, [Validators.required]],
    typePoseZone1: ['', [Validators.required]],
    surfaceZone1: [null, [Validators.required, Validators.pattern('^\\d+(\\.\\d{1,2})?$')]],
    azimutZone1: [null, [Validators.required, Validators.pattern('^-?(180|\\d{1,2}|1[0-7]\\d)$')]],
    typeToitureZone1: [''],
    pvReadyZone1: [false],
    inclinaisonZone1: [null, [Validators.pattern('^\\d+$')]],
    typeVehiculeParkingZone1: [''],
    typePlaceParkingZone1: [''],
    typePoseZone2: [''],
    surfaceZone2: [null, [Validators.pattern('^\\d+(\\.\\d{1,2})?$')]],
    azimutZone2: [null, [Validators.pattern('^-?(180|\\d{1,2}|1[0-7]\\d)$')]],
    typeToitureZone2: [''],
    pvReadyZone2: [false],
    inclinaisonZone2: [null, [Validators.pattern('^\\d+$')]],
    typeVehiculeParkingZone2: [''],
    typePlaceParkingZone2: [''],
    typePoseZone3: [''],
    surfaceZone3: [null, [Validators.pattern('^\\d+(\\.\\d{1,2})?$')]],
    azimutZone3: [null, [Validators.pattern('^-?(180|\\d{1,2}|1[0-7]\\d)$')]],
    typeToitureZone3: [''],
    pvReadyZone3: [false],
    inclinaisonZone3: [null, [Validators.pattern('^\\d+$')]],
    typeVehiculeParkingZone3: [''],
    typePlaceParkingZone3: [''],
    prixApportAffaireHtWc: [null],
    travauxDiversHT: [null],
    travauxVrdHT: [null],
    travauxDistanceVoirieVrd: [null],
    prm: [null],
    ptrAC: [false],
    tarifHch: [null],
    tarifHph: [null],
    tarifHpt: [null],
    tarifHpb: [null],
    tarifHcb: [null],
    dureeContrat: [null, [Validators.required]],
    distanceRaccordementPublic: [null],
    raccordementPublicCoordinates: [null],
    typeGammePanneau:['CRE', [Validators.required]],
    typeGammeOnduleur:['STRING', [Validators.required]],
    coffretDc: [false],
    paratonnerre: [false],
    aerodrome: [false],
    stationMeteo: [false],
    dispositifNonInjection: [false],
    dispoTGBT: [false],
    automate: [false],
    deposeCandelabre: [null],
    poseCandelabre: [null],
    eclairageSousOmbriere: [false],
    descenteEpAlu: [false],
    nbAbattageArbres: [null],
    mlClotureSol: [null],
    nbPortailsSol: [null],
    mlGardeCorpsProvisoire: [null],
    mlLigneDeVie: [null],
    nbEchelleCrinoline: [null],
    modeDebug:[false],
    forcerSoulteEtRenteInialeVT:[false],
    lotPVMarcheTCE:[false],
  })

  // Méthode appelée lorsqu'un bouton radio est cliqué
  onRadioClick(code: string | null, controleName: string) {
    // @ts-ignore
    this.sunleonForm.get(controleName).setValue(code)
  }

  loadPrmCodes(): void {
    this.bilanEnergetiqueService.getPrm().subscribe((data) => {
      this.prmCodes = data
    })
  }

  deletePrm(event: MouseEvent, codePrm: string): void {
    event.preventDefault()
    event.stopPropagation()

    const modalRef = this.modalService.open(ConfirmationModalComponent)
    modalRef.componentInstance.titre = 'Suppression du PRM'
    modalRef.componentInstance.message = `Le PRM ${codePrm} et toutes ses lignes seront supprimés.`
    modalRef.componentInstance.confirmation = 'Voulez-vous continuer ?'

    modalRef.result.then((confirmed: boolean) => {
      if (!confirmed) {
        return
      }

      this.bilanEnergetiqueService.deletePrm(codePrm).subscribe({
        next: () => {
          this.prmCodes = this.prmCodes.filter((prm) => prm.code !== codePrm)
          if (this.sunleonForm.get('prm')?.value === codePrm) {
            this.sunleonForm.get('prm')?.reset()
          }
          this.toastr.success(`Le PRM ${codePrm} a été supprimé.`)
        },
        error: () => {
          this.toastr.error(`Erreur lors de la suppression du PRM ${codePrm}.`)
        },
      })
    },  (): void => {}
    )
  }

  openModal() {
    this.selectedFormat = null; 
    this.nomCourbeCharge = ''; 
    this.nomCourbeChargeError = false;
    this.selectedFile = undefined; 
    this.modalService
      .open(this.modalContent, { ariaLabelledBy: 'modal-basic-title', backdrop: 'static', keyboard: false })
      .result.then(
        () => {
          // Traitement à effectuer lorsque le modal est fermé (si nécessaire)
          this.formModalIsSubmitting = false
        },
        () => {
          // Traitement à effectuer si le modal est fermé avec un rejet (si nécessaire)
          this.formModalIsSubmitting = false
        }
      )
  }

  onFormatChange(): void {
    this.nomCourbeCharge = ''; 
    this.nomCourbeChargeError = false;
    this.selectedFile = undefined; 
    this.validateNomCourbeCharge();
  }

  onFileSelected(event: Event): void {
    const inputElement = event.target as HTMLInputElement
    if (inputElement?.files) {
      this.selectedFile = inputElement.files[0]
    }
  }

   validateNomCourbeCharge(): void {
    this.nomCourbeChargeError = !this.nomCourbeCharge.trim();
  }

  onSubmit(): void {
    this.validateNomCourbeCharge();
    if (this.selectedFormat === 'enedis' && this.nomCourbeChargeError) {
        this.toastr.error('Le code PRM est requis pour le format Enedis');
        return;
    }
    if (!this.selectedFile) {
      this.toastr.error('Aucun fichier sélectionné');
      return;
    }
    if (this.selectedFile) {
      this.formModalIsSubmitting = true;
      this.pieceJointeService.uploadPieceJointeAndReturnDownloadUrl(this.selectedFile, this.nomCourbeCharge + '.csv').subscribe({
        next: (filename: string) => {
          console.log('Filename from S3:', filename);
          this.fileUploadService.uploadFile(filename, this.selectedFormat === 'enedis').subscribe({
            next: () => {
              this.toastr.success('Fichier uploadé avec succès. Nom du fichier : ' + filename);
              this.formModalIsSubmitting = false;
              this.modalService.dismissAll();
              this.selectedFile = undefined;
              this.nomCourbeCharge = '';
            },
            error: (error) => {
              this.toastr.error('Erreur lors de l\'upload du fichier vers l\'API Sunleon : ' + (error.message || 'Erreur inconnue'));
              this.formModalIsSubmitting = false;
              this.modalService.dismissAll();
            }
          });
        },
        error: (error) => {
          this.toastr.error('Erreur lors de l\'upload du fichier vers S3 : ' + (error.message || 'Erreur inconnue'));
          this.formModalIsSubmitting = false;
          this.modalService.dismissAll();
        }
      });
    } else {
      this.toastr.error('Aucun fichier sélectionné');
      this.formModalIsSubmitting = false;
      this.modalService.dismissAll();
    }
  }

  monitorProcessStatus(processId: string) {
    this.fileUploadService.getProcessStatus(processId).subscribe((result) => {
      this.status = result.status
      if (this.status === 'COMPLETED') {
        this.formModalIsSubmitting = false
        this.toastr.success('Le fichier CSV a été importé avec le code PRM : ' + result.message)
        this.sunleonForm.get('prm').setValue(result.message)
        this.modalService.dismissAll()
        this.processIdEnregistrementSimulation = undefined
      } else {
        if (this.status === 'FAILED') {
          this.formModalIsSubmitting = false
          this.toastr.error(result.message)
          this.modalService.dismissAll()
          this.processIdEnregistrementSimulation = undefined
        } else {
          this.toastr.info(result.message)
        }
      }
    })
  }

  ngOnInit(): void {
    this.user = this.authService.connectedUser
    this.referenceService.getModeValorisation().subscribe((data) => {
      this.modeValorisations = data
    })
    this.referenceService.getTypePose().subscribe((data) => {
      this.typePoses = data
    })
    this.referenceService.getTypeToiture().subscribe((data) => {
      this.typeToitures = data
    })
    this.referenceService.getTypeParking().subscribe((data) => {
      this.typeParkings = data
    })
    this.referenceService.getTypePlace().subscribe((data) => {
      this.typePlaces = data
    })
    this.referenceService.getDureeContrat().subscribe((data) => {
      this.dureeContrats = data
    })
    this.loadPrmCodes()

    this.referenceService.getTypeGammePanneau().subscribe((data) => {
      this.typeGammePanneaux = data
    })

    this.referenceService.getTypeGammeOnduleur().subscribe((data) => {
      this.typeGammeOnduleurs = data
    })

    this.parametres$ = this.parametreService.getOverloadableParametres(); 

        this.sunLeonService.overloadableParametres$.subscribe(param => {
      if (param) {
        this.parametresSimple.set(param.code, param.value);
      }
    });

    this.sunLeonService.overloadableParametresTableau$.subscribe(param => {
      if (param) {
        this.parametresTableau.set(param.parametreDto.code, param.valeurs);
      }
    });

    this.sunLeonService.overloadableParametresSpécifique$.subscribe(param => {
      if (param) {
        this.parametresSpécifique.set(param.parametreDto.code, param.valeurs);
      }
    });


    this.initTypePoseZone(
      'typePoseZone1',
      'typePoseZone2',
      'typePoseZone3',
      'deposeCandelabre',
      'poseCandelabre',
      'eclairageSousOmbriere',
      'descenteEpAlu',
      'nbAbattageArbres',
      'mlClotureSol',
      'nbPortailsSol',
      'mlGardeCorpsProvisoire',
      'mlLigneDeVie',
      'nbEchelleCrinoline',
      'surfaceZone1',
      'azimutZone1',
      'typeToitureZone1',
      'pvReadyZone1',
      'inclinaisonZone1',
      'typeVehiculeParkingZone1',
      'typePlaceParkingZone1'
    )

    this.initTypePoseZone(
      'typePoseZone2',
      'typePoseZone1',
      'typePoseZone3',
      'deposeCandelabre',
      'poseCandelabre',
      'eclairageSousOmbriere',
      'descenteEpAlu',
      'nbAbattageArbres',
      'mlClotureSol',
      'nbPortailsSol',
      'mlGardeCorpsProvisoire',
      'mlLigneDeVie',
      'nbEchelleCrinoline',
      'surfaceZone2',
      'azimutZone2',
      'typeToitureZone2',
      'pvReadyZone2',
      'inclinaisonZone2',
      'typeVehiculeParkingZone2',
      'typePlaceParkingZone2'
    )
    this.initTypePoseZone(
      'typePoseZone3',
      'typePoseZone1',
      'typePoseZone2',
      'deposeCandelabre',
      'poseCandelabre',
      'eclairageSousOmbriere',
      'descenteEpAlu',
      'nbAbattageArbres',
      'mlClotureSol',
      'nbPortailsSol',
      'mlGardeCorpsProvisoire',
      'mlLigneDeVie',
      'nbEchelleCrinoline',
      'surfaceZone3',
      'azimutZone3',
      'typeToitureZone3',
      'pvReadyZone3',
      'inclinaisonZone3',
      'typeVehiculeParkingZone3',
      'typePlaceParkingZone3'
    )
    this.initModeValorisation(
      'modeValorisation',
      'prm',
      'puissanceSouscriteKVA',
      'tarifHch',
      'tarifHph',
      'tarifHpt',
      'tarifHpb',
      'tarifHcb',
      'distanceRaccordementPublic',
      'travauxDistanceVoirieVrd',
      'dispositifNonInjection',
      'dispoTGBT',
      'automate'
    )

    this.initGammeOnduleur(
      'typeGammeOnduleur',
      'coffretDc',
      'paratonnerre')

    this.sunleonForm.get('latitude')!.valueChanges
    .pipe(debounceTime(500))
    .subscribe(() => this.tryGetDepartement());

    this.sunleonForm.get('longitude')!.valueChanges
      .pipe(debounceTime(500))
      .subscribe(() => this.tryGetDepartement());
  }

  initTypePoseZone(
    typePose: string,
    typePoseAutreZone1: string,
    typePoseAutreZone2: string,
    deposeCandelabre: string,
    poseCandelabre: string,
    eclairageSousOmbriere: string,
    descenteEpAlu: string,
    nbAbattageArbres: string,
    mlClotureSol: string,
    nbPortailsSol: string,
    mlGardeCorpsProvisoire: string,
    mlLigneDeVie: string,
    nbEchelleCrinoline: string,
    surfaceZone: string,
    azimutZone: string,
    typeToitureZone: string,
    pvReadyZone: string,
    inclinaisonZone: string,
    typeVehiculeParkingZone: string,
    typePlaceParkingZone: string

  ) {
    this.sunleonForm.get(typePose).valueChanges.subscribe((typePoseZone) => {
      const constSurfaceZone = this.sunleonForm.get(surfaceZone)
      const constAzimutZone = this.sunleonForm.get(azimutZone)

      const constTypeToitureZone = this.sunleonForm.get(typeToitureZone)
      const constPvReadyZone = this.sunleonForm.get(pvReadyZone)
      const constInclinaisonZone = this.sunleonForm.get(inclinaisonZone)
      const consttypeVehiculeParkingZone = this.sunleonForm.get(typeVehiculeParkingZone)
      const consttypePlaceParkingZone = this.sunleonForm.get(typePlaceParkingZone)

      const constTypePoseAutreZone1 = this.sunleonForm.get(typePoseAutreZone1)
      const constTypePoseAutreZone2 = this.sunleonForm.get(typePoseAutreZone2)

      const constDeposeCandelabre = this.sunleonForm.get(deposeCandelabre)
      const constPoseCandelabre = this.sunleonForm.get(poseCandelabre)
      const constEclairageSousOmbriere = this.sunleonForm.get(eclairageSousOmbriere)
      const constDescenteEpAlu = this.sunleonForm.get(descenteEpAlu)

      const constNbAbattageArbres = this.sunleonForm.get(nbAbattageArbres)

      const constMlClotureSol = this.sunleonForm.get(mlClotureSol)
      const constNbPortailsSol = this.sunleonForm.get(nbPortailsSol)

      const constMlGardeCorpsProvisoire = this.sunleonForm.get(mlGardeCorpsProvisoire)
      const constMlLigneDeVie = this.sunleonForm.get(mlLigneDeVie)
      const constNbEchelleCrinoline = this.sunleonForm.get(nbEchelleCrinoline)

      if (typePoseZone) {
        constSurfaceZone.setValidators([Validators.required, Validators.pattern('^\\d+(\\.\\d{1,2})?$')])
        constAzimutZone.setValidators([Validators.required, Validators.pattern('^-?(180|\\d{1,2}|1[0-7]\\d)$')])

        /** Si aucune pose OMBRIERE alors les 3 champs Capex par type pose doit être initialisés **/
        if (typePoseZone != 'OMBRIERE' && constTypePoseAutreZone1.value != 'OMBRIERE' && constTypePoseAutreZone2.value != 'OMBRIERE') {
            constDeposeCandelabre.reset()
            constPoseCandelabre.reset()
            constEclairageSousOmbriere.setValue(false)
            constDescenteEpAlu.setValue(false)
            constNbAbattageArbres.reset()
        }

        /** Si aucune pose SOL alors les 2 champs Capex par type pose doit être initialisés **/
        if (typePoseZone != 'SOL' && constTypePoseAutreZone1.value != 'SOL' && constTypePoseAutreZone2.value != 'SOL') {
          constMlClotureSol.reset()
          constNbPortailsSol.reset()
        }

        /** Si aucune pose TOITURE alors les champs Capex par type pose doit être initialisés **/
        if (typePoseZone != 'TOITURE' && constTypePoseAutreZone1.value != 'TOITURE' && constTypePoseAutreZone2.value != 'TOITURE') {
          constMlGardeCorpsProvisoire.reset()
          constMlLigneDeVie.reset()
          constNbEchelleCrinoline.reset()
        }


        if (typePoseZone === 'TOITURE') {
          constTypeToitureZone.setValidators([Validators.required])
          constPvReadyZone.setValidators([Validators.required])
          constInclinaisonZone.setValidators([Validators.required])
          constTypeToitureZone.reset()
          constPvReadyZone.reset()
          constInclinaisonZone.reset()

          consttypeVehiculeParkingZone.setValidators([Validators.nullValidator])
          consttypePlaceParkingZone.setValidators([Validators.nullValidator])
          consttypeVehiculeParkingZone.reset()
          consttypePlaceParkingZone.reset()
        }
        if (typePoseZone === 'OMBRIERE') {
          consttypeVehiculeParkingZone.setValidators([Validators.required])
          consttypeVehiculeParkingZone.reset()
          consttypePlaceParkingZone.reset()

          constTypeToitureZone.setValidators([Validators.nullValidator])
          constPvReadyZone.setValidators([Validators.nullValidator])
          constInclinaisonZone.setValidators([Validators.nullValidator])

          constTypeToitureZone.reset()
          constPvReadyZone.reset()
          constInclinaisonZone.reset()
        }

        if (typePoseZone === 'SOL') {
          constTypeToitureZone.setValidators([Validators.nullValidator])
          constPvReadyZone.setValidators([Validators.nullValidator])
          constInclinaisonZone.setValidators([Validators.nullValidator])
          consttypeVehiculeParkingZone.setValidators([Validators.nullValidator])
          consttypePlaceParkingZone.setValidators([Validators.nullValidator])

          constTypeToitureZone.reset()
          constPvReadyZone.reset()
          constInclinaisonZone.reset()
          consttypeVehiculeParkingZone.reset()
          consttypePlaceParkingZone.reset()
        }
      } else {
        constSurfaceZone.setValidators([Validators.pattern('^\\d+(\\.\\d{1,2})?$')])
        constAzimutZone.setValidators([Validators.pattern('^-?(180|\\d{1,2}|1[0-7]\\d)$')])
        constTypeToitureZone.setValidators([Validators.nullValidator])
        constPvReadyZone.setValidators([Validators.nullValidator])
        constInclinaisonZone.setValidators([Validators.nullValidator])
        consttypeVehiculeParkingZone.setValidators([Validators.nullValidator])
        consttypePlaceParkingZone.setValidators([Validators.nullValidator])

        constSurfaceZone.reset()
        constAzimutZone.reset()
        constTypeToitureZone.reset()
        constPvReadyZone.reset()
        constInclinaisonZone.reset()
        consttypeVehiculeParkingZone.reset()
        consttypePlaceParkingZone.reset()
      }
    })

    this.sunleonForm.get(typeVehiculeParkingZone).valueChanges.subscribe((typeVehiculeParking) => {
      const constTypeVehiculeParkingZone = this.sunleonForm.get(typeVehiculeParkingZone)
      const constTypePlaceParkingZone = this.sunleonForm.get(typePlaceParkingZone)
      constTypeVehiculeParkingZone.setValidators([Validators.required])
      if (typeVehiculeParking === 'VL') {
        constTypePlaceParkingZone.setValidators([Validators.required])
      } else {
        constTypePlaceParkingZone.reset()
      }
    })

    this.sunleonForm.get(typeToitureZone).valueChanges.subscribe((valTypeToitureZone: string) => {
      const constAzimutZone = this.sunleonForm.get(azimutZone);
    
      if (valTypeToitureZone === 'BETON' || valTypeToitureZone === 'TAN_ETANCHE') {
        
        switch(azimutZone) {
          case "azimutZone1":
            this.azimutZone1Label = "Azimut (compris entre -90 et 90, SUD = 0)"
            break;

          case "azimutZone2":
            this.azimutZone2Label = "Azimut (compris entre -90 et 90, SUD = 0)"
            break;

          case "azimutZone3":
            this.azimutZone3Label = "Azimut (compris entre -90 et 90, SUD = 0)"
            break;
        }

        constAzimutZone.setValidators([Validators.required, Validators.pattern('^-?([0-8][0-9]|9[0])$')]);
      } else {

        switch(azimutZone) {
          case "azimutZone1":
            this.azimutZone1Label = "Azimut (compris entre -180 et 180, SUD = 0)"
            break;

          case "azimutZone2":
            this.azimutZone2Label = "Azimut (compris entre -180 et 180, SUD = 0)"
            break;

          case "azimutZone3":
            this.azimutZone3Label = "Azimut (compris entre -180 et 180, SUD = 0)"
            break;
        }

        constAzimutZone.reset()
      }
    })
  }

  initModeValorisation(
    modeValorisation: string,
    prmAC: string,
    puissanceSouscriteKVAac: string,
    tarifHchAc: string,
    tarifHphAc: string,
    tarifHptAc: string,
    tarifHpbAc: string,
    tarifHcbAc: string,
    distanceRaccordementPublic: string,
    distanceVoirieVRD: string,
    dispositifNonInjectionAC: string,
    dispoTGBTAC: string,
    automateAC: string
  ) {
    this.sunleonForm.get(modeValorisation).valueChanges.subscribe((mode) => {
      const prm = this.sunleonForm.get(prmAC)
      const puissanceSouscriteKVA = this.sunleonForm.get(puissanceSouscriteKVAac)
      const tarifHch = this.sunleonForm.get(tarifHchAc)
      const tarifHph = this.sunleonForm.get(tarifHphAc)
      const tarifHpt = this.sunleonForm.get(tarifHptAc)
      const tarifHpb = this.sunleonForm.get(tarifHpbAc)
      const tarifHcb = this.sunleonForm.get(tarifHcbAc)
      const raccordementEnedis = this.sunleonForm.get(distanceRaccordementPublic)
      const distanceVoirie = this.sunleonForm.get(distanceVoirieVRD)
      const dispositifNonInjection = this.sunleonForm.get(dispositifNonInjectionAC)
      const dispoTGBT = this.sunleonForm.get(dispoTGBTAC)
      const automate = this.sunleonForm.get(automateAC)

      if (mode === 'AC') {
        prm.setValidators([Validators.required])
        puissanceSouscriteKVA.setValidators([Validators.required])
        tarifHch.setValidators([Validators.required])
        tarifHph.setValidators([Validators.required])
        tarifHpt.setValidators([Validators.required])
        tarifHpb.setValidators([Validators.required])
        tarifHcb.setValidators([Validators.required])
        raccordementEnedis.setValidators([Validators.nullValidator])
        raccordementEnedis.reset()
      } else {
        prm.setValidators([Validators.nullValidator])
        puissanceSouscriteKVA.setValidators([Validators.nullValidator])
        tarifHch.setValidators([Validators.nullValidator])
        tarifHph.setValidators([Validators.nullValidator])
        tarifHpt.setValidators([Validators.nullValidator])
        tarifHpb.setValidators([Validators.nullValidator])
        tarifHcb.setValidators([Validators.nullValidator])
        prm.reset()
        puissanceSouscriteKVA.reset()
        distanceVoirie.reset()
        tarifHch.reset()
        tarifHph.reset()
        tarifHpt.reset()
        tarifHpb.reset()
        tarifHcb.reset()
        raccordementEnedis.setValidators([Validators.required])
        dispositifNonInjection.setValue(false)
        dispoTGBT.setValue(false)
        automate.setValue(false)
      }
    })
  }

  initGammeOnduleur(
    gammeOnduleur: string,
    coffretDC: string,
    paratonnerre: string
  ) {
    this.sunleonForm.get(gammeOnduleur).valueChanges.subscribe((onduleur) => {
      const constCoffretDC = this.sunleonForm.get(coffretDC)
      const constParatonnerre = this.sunleonForm.get(paratonnerre)
      if (onduleur != 'STRING') {
        constCoffretDC.setValue(false)
        constParatonnerre.setValue(false)
      }
    })
  }

  ngOnDestroy() {
    this.subscription.unsubscribe()
  }

  getSessionSaveFromForm() {
    const formValue = this.sunleonForm.value
    const zoneDto: SessionZoneSaveDto[] = []
    const communDto: SessionCommunSaveDto = {
      nomClient: formValue.nomClient,
      nomProjet: formValue.nomProjet,
      numMonday: formValue.numMonday,
      latitude: formValue.latitude,
      longitude: formValue.longitude,
      departement: formValue.departement,
      puissanceSouscriteKVA: formValue.puissanceSouscriteKVA,
      modeValorisation: formValue.modeValorisation,
      prixApportAffaireHtWc: formValue.prixApportAffaireHtWc === null ? 0 : formValue.prixApportAffaireHtWc,
      travauxDiversHT: formValue.travauxDiversHT === null ? 0 : formValue.travauxDiversHT,
      travauxDistanceVoirieVrd: formValue.travauxDistanceVoirieVrd === null ? 0 : formValue.travauxDistanceVoirieVrd,
      ptrAC : formValue.ptrAC,
      prm: formValue.prm,
      aEnregistrer: true,
      tarifHch: formValue.tarifHch,
      tarifHph: formValue.tarifHph,
      tarifHpt: formValue.tarifHpt,
      tarifHpb: formValue.tarifHpb,
      tarifHcb: formValue.tarifHcb,
      dureeContrat: formValue.dureeContrat,
      distanceRaccordementPublic: formValue.distanceRaccordementPublic,
      raccordementPublicCoordinates: formValue.raccordementPublicCoordinates,
      typeGammePanneau: formValue.typeGammePanneau,
      typeGammeOnduleur: formValue.typeGammeOnduleur,
      coffretDc: formValue.coffretDc,
      paratonnerre: formValue.paratonnerre,
      aerodrome: formValue.aerodrome,
      stationMeteo: formValue.stationMeteo,
      dispositifNonInjection: formValue.dispositifNonInjection,
      dispoTGBT: formValue.dispoTGBT,
      automate: formValue.automate,
      deposeCandelabre: formValue.deposeCandelabre === null ? 0 : formValue.deposeCandelabre,
      poseCandelabre: formValue.poseCandelabre === null ? 0 : formValue.poseCandelabre,
      eclairageSousOmbriere: formValue.eclairageSousOmbriere,
      descenteEpAlu: formValue.descenteEpAlu,
      nbAbattageArbres: formValue.nbAbattageArbres === null ? 0 : formValue.nbAbattageArbres,
      mlClotureSol: formValue.mlClotureSol === null ? 0 : formValue.mlClotureSol,
      nbPortailsSol: formValue.nbPortailsSol === null ? 0 : formValue.nbPortailsSol,
      mlGardeCorpsProvisoire: formValue.mlGardeCorpsProvisoire === null ? 0 : formValue.mlGardeCorpsProvisoire,
      mlLigneDeVie: formValue.mlLigneDeVie === null ? 0 : formValue.mlLigneDeVie,
      nbEchelleCrinoline: formValue.nbEchelleCrinoline === null ? 0 : formValue.nbEchelleCrinoline,
      modeDebug : formValue.modeDebug,
      forcerSoulteEtRenteInialeVT: formValue.forcerSoulteEtRenteInialeVT,
      lotPVMarcheTCE: formValue.lotPVMarcheTCE
    }

    zoneDto.push({
      id: 1,
      typePose: formValue.typePoseZone1,
      surface: formValue.surfaceZone1,
      azimut: formValue.azimutZone1,
      typeToiture: formValue.typeToitureZone1 === '' ? null : formValue.typeToitureZone1,
      orientation: null,
      pvReady: formValue.pvReadyZone1,
      inclinaison: formValue.inclinaisonZone1,
      typeVehiculeParking: formValue.typeVehiculeParkingZone1 === '' ? null : formValue.typeVehiculeParkingZone1,
      typePlaceParking: formValue.typePlaceParkingZone1 === '' ? null : formValue.typePlaceParkingZone1,
      polygons: null,
      azimutCoordinates:null,
      panneaux: null
    })

    if (formValue.typePoseZone2 != '') {
      zoneDto.push({
        id: 2,
        typePose: formValue.typePoseZone2,
        surface: formValue.surfaceZone2,
        azimut: formValue.azimutZone2,
        typeToiture: formValue.typeToitureZone2 === '' ? null : formValue.typeToitureZone2,
        orientation: null,
        pvReady: formValue.pvReadyZone2,
        inclinaison: formValue.inclinaisonZone2,
        typeVehiculeParking: formValue.typeVehiculeParkingZone2 === '' ? null : formValue.typeVehiculeParkingZone2,
        typePlaceParking: formValue.typePlaceParkingZone2 === '' ? null : formValue.typePlaceParkingZone2,
        polygons: null,
        azimutCoordinates:null,
        panneaux: null
      })
    }

    if (formValue.typePoseZone3 != '') {
      zoneDto.push({
        id: 3,
        typePose: formValue.typePoseZone3,
        surface: formValue.surfaceZone3,
        azimut: formValue.azimutZone3,
        typeToiture: formValue.typeToitureZone3 === '' ? null : formValue.typeToitureZone3,
        orientation: null,
        pvReady: formValue.pvReadyZone3,
        inclinaison: formValue.inclinaisonZone3,
        typeVehiculeParking: formValue.typeVehiculeParkingZone3 === '' ? null : formValue.typeVehiculeParkingZone3,
        typePlaceParking: formValue.typePlaceParkingZone3 === '' ? null : formValue.typePlaceParkingZone3,
        polygons: null,
        azimutCoordinates:null,
        panneaux: null
      })

    }

    return {
      commun: communDto,
      zones: zoneDto,
      parametres: Object.fromEntries(this.parametresSimple),
      parametresTableau: Object.fromEntries(this.parametresTableau),
      parametresSpecifique: Object.fromEntries(this.parametresSpécifique)
    } as SessionSaveDto
  }

  saveSimulation() {
    if (!this.sunleonForm.valid) {
      this.sunleonForm.markAllAsTouched()
      scrollToInvalidElement()
      return
    }

    this.formIsSubmitting = true
    const simulationSave = this.getSessionSaveFromForm()
    this.openDialogLivrable(simulationSave)
  }

  transformSession(formData : any, simulationSave : SessionSaveDto) {
    this.sunLeonService.transformSession(simulationSave).subscribe({
      next:(data: ProcessResultDto) => {
        // Divisez la chaîne en utilisant le caractère "|"
        const elements: string[] = data.message.split('|')
        // Maintenant, elements[0] contient "Premier Élément" et elements[1] contient "Deuxième Élément"
        // Vous pouvez utiliser ces éléments comme vous le souhaitez
        this.processIdEnregistrementSimulation = elements[0]
        this.processIdCreationCsv = elements[1]
        this.monitorProcessStatusSession(this.processIdEnregistrementSimulation, this.processIdCreationCsv, formData, data.idSimulation)
      },
      error:() => {
        this.formIsSubmitting = false
        this.modalService.dismissAll()
      }}
    )
  }

  openModalSuccess() {
    this.modalService
      .open(this.modalContentSuccess, { ariaLabelledBy: 'modal-basic-title', backdrop: 'static', keyboard: false })
      .result.then(
      () => {
        this.apiMessageSuccess = '';
        // Traitement à effectuer lorsque le modal est fermé (si nécessaire)
        this.formModalIsSubmitting = false
      },
      () => {
        // Traitement à effectuer si le modal est fermé avec un rejet (si nécessaire)
        this.apiMessageSuccess = '';
        this.formModalIsSubmitting = false
      }
    )
  }

  monitorProcessStatusSession(processIdEnregistrementSimulation: string, processIdCreationCsv: string, formData: any, idSimulation: number) {
    this.sunLeonService.getProcessStatusSession(processIdEnregistrementSimulation).subscribe((result) => {
      this.status = result.status
      if (this.status === 'COMPLETED') {
        this.toastr.info(result.message)
        this.sunLeonService
          .checkSecondProcessStatus(processIdCreationCsv, processIdEnregistrementSimulation, idSimulation)
          .subscribe((result) => {
            this.status = result.status
            if (this.status === 'COMPLETED') {
              if(result.idSimulation != null) {
                this.getLivrables(result.idSimulation, formData).then(() => {
                  this.sendFilesToGoogleDrive(formData, result.idSimulation)
                    this.sunLeonService.generateLivrable(idSimulation, formData.idFolder, formData.csvSlide, formData.csvDevis, formData.csvVE).subscribe({
                      next: (res: any) => {
                        if (res.status == "OK") {
                          const modalRef = this.modalService.open(ConfirmationModalComponent);
                          modalRef.componentInstance.titre = 'Simulation '+idSimulation+' terminé !';
                          modalRef.componentInstance.message = 'Souhaitez-vous ouvrir le dossier dans un nouvel onglet?';
                          modalRef.componentInstance.confirmation = '';
                          modalRef.result.then((confirmed : any) => {
                            if (confirmed) {
                              window.open(formData.urlFolder, '_blank');
                            }
                          });
                        } else {
                          console.error("Erreur ", res.status, " : ", res.message);
                          this.toastr.error(res.message)
                        }
                      },
                      error: (err) => {
                        console.error("Erreur HTTP :", err);
                        this.toastr.error(result.message)
                      }
                    });
                }) 
              }
              if (result.urlCsv != null) {
                saveAs(result.urlCsv, result.nomCsv)
                this.urlDownloadSimu = result.urlCsv
                this.toastr.success(result.message)
                this.apiMessageSuccess = result.message;
                this.openModalSuccess();
                this.formIsSubmitting = false
              }
              this.processIdCreationCsv = undefined
            } else {
              if (this.status === 'FAILED') {
                if(result.idSimulation != null) {
                  this.getLivrables(result.idSimulation, formData).then(() => {
                    this.sendFilesToGoogleDrive(formData, result.idSimulation)
                    this.sunLeonService.generateLivrable(idSimulation, formData.idFolder, formData.csvSlide, formData.csvDevis, formData.csvVE).subscribe({
                      next: (res: any) => {
                        if (res.status == "OK") {
                          const modalRef = this.modalService.open(ConfirmationModalComponent);
                          modalRef.componentInstance.titre = 'Simulation '+idSimulation+' terminé !';
                          modalRef.componentInstance.message = 'Souhaitez-vous ouvrir le dossier dans un nouvel onglet?';
                          modalRef.componentInstance.confirmation = '';
                          modalRef.result.then((confirmed : any) => {
                              if (confirmed) {
                                window.open(formData.urlFolder, '_blank');
                              }
                          });
                        } else {
                          console.error("Erreur ", res.status, " : ", res.message);
                          this.toastr.error(res.message)
                        }
                      },
                      error: (err) => {
                        console.error("Erreur HTTP :", err);
                        this.toastr.error(result.message)
                      }
                    });
                  }) 
                }
                this.formIsSubmitting = false
                this.toastr.error(result.message)
                this.processIdCreationCsv = undefined
              } else {
                this.toastr.info(result.message)
              }
            }
          })
      } else {
        if (this.status === 'FAILED') {
          this.formIsSubmitting = false
          this.toastr.error(result.message)
          this.processIdEnregistrementSimulation = undefined
        } else {
          this.toastr.info(result.message)
        }
      }
    })
  }

  tryGetDepartement(): void {
  const lat = this.sunleonForm.get('latitude')?.value;
  const long = this.sunleonForm.get('longitude')?.value;
  let departement: string | null = null;

    if (this.coordsAreValid(lat, long)) {
      this.geomapDomainService.getDepartement$(lat, long).subscribe((response: ReverseGeoCodeGoogleDto) => {
        if (response) {
          departement = response.postalCode.substring(0,2)
        }

        this.sunleonForm.get('departement')?.patchValue(departement ? departement : null);
      });;
    }
    else {
      this.sunleonForm.get('departement')?.patchValue(null);
    }
  }

  coordsAreValid(lat: number, long: number): boolean {
    return (
      typeof lat === 'number' && typeof long === 'number' &&
      !isNaN(lat) && !isNaN(long) &&
      lat >= -90 && lat <= 90 &&
      long >= -180 && long <= 180
    );
  }

  openDialogLivrable(simulationSave : SessionSaveDto): void {
      const formValueProjet = this.sunleonForm.value
      const modalRef = this.modalService.open(ModalGenerationLivrableComponent, { size: 'lg' });
        modalRef.componentInstance.nomClient = formValueProjet.nomClient;
        modalRef.componentInstance.nomProjet = formValueProjet.nomProjet;
        modalRef.componentInstance.isParentForm = false;
  
        modalRef.result.then((formData : any) => {
          if (formData) {
            this.transformSession(formData, simulationSave)
          }
      });
  }

  async getLivrables(idSimulation: number, formData: any) {
    const calls = [];

    if (formData.csvSlide) {
      calls.push({
        obs: this.sunLeonService.getLivrableAsCsv(idSimulation),
        filename: "Presentation_" + idSimulation + ".csv",
        type: "csvPresentation",
      });
    }
    if (formData.csvDevis) {
      calls.push({
        obs: this.sunLeonService.getGenerateurDevisAsCsv(idSimulation),
        filename: "Devis_" + idSimulation + ".csv",
        type: "csvDevis",
      });
    }
    if (formData.csvVE) {
      calls.push({
        obs: this.sunLeonService.getGenerateurValidationEngagementAsCsv(idSimulation),
        filename: "Validation_Engagement_" + idSimulation + ".csv",
        type: "csvVE",
      });
    }

    for (const call of calls) {
      const content = await firstValueFrom(call.obs);
      if (content) {
        const contentDisposition = content.headers.get('Content-Disposition');

        let filename = call.filename;
        if (contentDisposition) {
          const matches = /filename="([^"]+)"/.exec(contentDisposition);
          if (matches != null && matches[1]) {
            filename = matches[1];
          }
        }

        const file = new Blob([content.body], { type: 'text/csv;charset=ISO-8859-1' });
        const url = window.URL.createObjectURL(file);

        const fileObj = new File([file], filename);

        if (call.type === "csvPresentation") {
          this.csvPresentation = fileObj;
        } else if (call.type === "csvDevis") {
          this.csvDevis = fileObj;
        } else if (call.type === "csvVE") {
          this.csvVE = fileObj;
        }

        const a = document.createElement('a');
        a.href = url;
        a.download = filename;
        a.click();

        window.URL.revokeObjectURL(url);
      }
    }
  }

  sendFilesToGoogleDrive(formData: any, idSimulation: number) {
    if (formData.idFolder) {
      const screenshotName = "capture_" + idSimulation + ".png";
      const newScreenshot: File | null = formData.screenshot
        ? new File([formData.screenshot], screenshotName)
        : null;

      const googleDriveDto: GoogleDriveDto = {
        folderId: formData.idFolder,
        screenshot: newScreenshot,
        urlDownloadSimu: this.urlDownloadSimu,
        simuFileName: 'SUNLEON_' + idSimulation + ".csv",
        csvPresentation: formData.csvSlide ? this.csvPresentation : null,
        csvDevis: formData.csvDevis ? this.csvDevis : null,
        csvVE: formData.csvVE ? this.csvVE : null,
      };

      this.googleDrivePickerService.saveToFolder(googleDriveDto).subscribe({
        next: () => {},
        error: (err: any) => {
          console.log("Erreur lors de l'envoi : " + err.message);
        },
      });
    } else {
      console.log("Pas de dossier sélectionné");
    }
  }

    iconClicked = false
    parametres$: Observable<ParametreDto[]>
    readonly modals: any = {
      [TypeEnum.SIMPLE]: ParametreSimpleModalComponent,
      [TypeEnum.TABLEAU]: ParametreTableauModalComponent,
      [TypeEnum.SPECIFIQUE]: ParametreSpecifiqueBddEnedisModalComponent,
    }
  
    selectedRowIndex: number | null = null
  
  datas: Map<string, string[][]> = new Map<string, string[][]>();
    private destroy$ = new Subject<void>();
    
    openEditionModal(parametreDto: ParametreDto) {
      const modalRef = this.modalService.open(this.modals[parametreDto.type], { size: 'lg' })
      const modalComponent = modalRef.componentInstance
      modalComponent.parametre = { ...parametreDto }
      modalComponent.overloadable = true
      modalRef.dismissed.subscribe((data) => {
        if (data) {
          parametreDto.valeur = data.valeur
        }
      })
    }
  
    openTableauEditionModal(parametreDto: ParametreDto) {
      const modalRef = this.modalService.open(this.modals[parametreDto.type], {size:'xl'} )
      const modalComponent = modalRef.componentInstance
      modalComponent.parametre = {...parametreDto}
      modalComponent.datas = {...(this.datas?.get(parametreDto.code) ?? {})};
      modalComponent.overloadable = true
      modalRef.dismissed.subscribe(data => {
        if (data) {
          this.datas.set(parametreDto.code, data.valeur.datas)
          parametreDto.valeur = data.valeur.parametreDto.valeur
        }
      })
    }
  
    openBddEnedisEditionModal(parametreDto: ParametreDto) {
      const modalRef = this.modalService.open(this.modals[parametreDto.type], {size:'xl'} )
      const modalComponent = modalRef.componentInstance
      modalComponent.parametre = {...parametreDto}
      modalComponent.overloadable = true
      modalRef.dismissed.subscribe(data => {
        if (data) {
          parametreDto.utilisateur = data.utilisateur
          parametreDto.dateModification = data.dateModification
        }
      })
    }
  
    handleRowClick(index: number): void {
      // Change la couleur de la ligne ou effectuez d'autres actions
      this.selectedRowIndex = index
    }

}

